<div class="h-100 w-100 d-flex align-items-center sfondo-loading">
	<div class="row">
		<img src="../../../../assets/img/Bertazzoni_logo_circolare.png" alt="" class="img-loading col-12 my-auto" />
	</div>
</div>
